export { trackEvent } from './firebase';

const PLAY_STORE_ID = 'com.baatcheetmobile';

// `location` identifies which CTA was clicked (navbar, footer, home_hero, ...).
// Google Play parses UTM-formatted referrer params into Play Console's
// Acquisition reports automatically — no extra SDK work needed to see
// which part of the website is actually driving installs.
export function playStoreUrl(location) {
  const referrer = encodeURIComponent(`utm_source=website&utm_medium=cta&utm_campaign=${location}`);
  return `https://play.google.com/store/apps/details?id=${PLAY_STORE_ID}&hl=en&referrer=${referrer}`;
}

// Per-session dedup only — mirrors the logPurchase Set pattern in the mobile
// app's src/utils/analytics.js. A full page reload resets these, same
// documented limitation as that pattern.
const firedRegistrationIds = new Set();

// Fired right after OTP verification succeeds — the earliest point in the
// 9-step partner funnel where someone has given a real phone number and
// genuinely started, long before most reach the final Lead event.
export function logPartnerRegistration(applicationId) {
  if (typeof window.fbq !== 'function') {
    console.log('[Meta Pixel] CompleteRegistration skipped — window.fbq not loaded yet', { applicationId });
    return;
  }
  if (applicationId != null) {
    if (firedRegistrationIds.has(applicationId)) {
      console.log('[Meta Pixel] CompleteRegistration skipped — already fired this session', { applicationId });
      return;
    }
    firedRegistrationIds.add(applicationId);
  }
  console.log('[Meta Pixel] firing CompleteRegistration', { applicationId });
  window.fbq('track', 'CompleteRegistration');
}

const firedLeadIds = new Set();

export function logPartnerLead(applicationId) {
  if (typeof window.fbq !== 'function') return;
  if (applicationId != null) {
    if (firedLeadIds.has(applicationId)) return;
    firedLeadIds.add(applicationId);
  }
  window.fbq('track', 'Lead');
}
